import declare from "dojo/_base/declare";
import Ref from "csi/heading/Ref";

export = declare(Ref, {

	/**
     * @override
     * Enable drag-fill
     */
	canCopy(ctxCopy, h) {
		return true;
	},

	/**
     * @override
     * Enable drag-fill
     */
	canPaste(ctxCopy, ctxPaste, h) {
		return true;
	},
});
